import { FC } from "react";
import classes from "./AccordionItemHeader.module.scss";

interface Props {
  onChange: () => void;
  isActive: boolean;
  value: any;
  theme?: string;
}

export const AccordionItemHeader: FC<Props> = ({
  children,
  onChange,
  isActive,
  value,
  theme = "red",
}) => {
  return (
    <div
      className={
        value === "PickUp" && isActive
          ? classes["accordion-item-header-pickup"]
          : classes["accordion-item-header"]
      }
      onClick={onChange}
      role="presentation"
    >
      <input
        type="radio"
        className={classes["input-radio"]}
        onChange={onChange}
        checked={isActive}
      />
      <span className={classes[`checkmark-${theme}`]}></span>
      <>{children}</>
    </div>
  );
};
